<div class="credit-account">
    <h2>Credit my account</h2>
    <div class="credit-account__trademe-credit-ping-wrapper">
        <div class="credit-account__trademe-credit">
            <div class="credit-account__trademe-credit-label">
                Trade Me credit
            </div>
            <div class="credit-account__trademe-credit-value">
                {{ (memberSummary | async)?.balance | tgCurrency }}
            </div>
        </div>
    </div>
    <form
        #form="ngForm"
        method="POST"
        (submit)="processAddCredit(form.valid)"
        autocomplete="off"
        name="form"
        novalidate
    >
        <tg-input-container
            label="Amount:"
            showValidation
            [description]="minimumTopUpValidationMessage"
        >
            <input
                [ngModel]="amountToTopUp"
                (ngModelChange)="updateAmountToTopUp($event)"
                [currencyMin]="minimumTopUpAmount"
                [currencyMax]="(accountStatus | async).maximumTopUpAmount"
                [validation]="{
                    currencyMax: maximumTopUpValidationMessage,
                    currencyMin: minimumTopUpValidationMessage
                }"
                tgTextInput
                name="topUpAmount"
                required
                currency
                class="credit-account-amount-to-topup__input"
            />
        </tg-input-container>
        <tm-ping-widget
            [totalToPay]="amountToTopUp"
            [triggerCardSubmit$]="submitCard$"
            [allowPaymentWithNegativeBalance]="true"
            (successCallback)="onUpdateFromPingWidget($event)"
            (loadedCallback)="onCCIFrameLoaded()"
        >
        </tm-ping-widget>
        <tg-row>
            <tg-col sm="12" lg="6">
                <button
                    (click)="hideCreditAccount()"
                    fullWidth
                    tgButton2
                    type="button"
                >
                    Cancel
                </button>
            </tg-col>
            <tg-col sm="12" lg="6">
                <button
                    [disabled]="addCreditIsLoading"
                    [tgLoading]="addCreditIsLoading"
                    fullWidth
                    tgButton2
                    tgStyle="primary"
                    type="submit"
                    class="credit-account-add-credit__button"
                >
                    Add credit
                </button>
            </tg-col>
        </tg-row>
    </form>
</div>
